import React from 'react'

export default function SetAddressPermissions() {
  return (
    <div>setAddressPermissions</div>
  )
}
